import request from '@/utils/request'

let Payment_receiptApi = {

  /*收款单列表*/
  list(data) {
    return request._post('/shop/plus.payment_receipt.Index/index', data);
},
/*添加收款单*/
add(data) {
    return request._post('/shop/plus.payment_receipt.Index/add', data);
},
/*修改收款单*/
edit(data) {
    return request._post('/shop/plus.payment_receipt.Index/edit', data);
},
confirm(data) {
    return request._post('/shop/plus.payment_receipt.Index/confirm', data);
},
confirmpay(data) {
    return request._post('/shop/plus.payment_receipt.Index/confirmpay', data);
},
/*删除收款单*/
del(data) {
    return request._post('/shop/plus.payment_receipt.Index/del', data);
},
/*收款单详情*/
detail(data) {
  return request._post('/shop/plus.payment_receipt.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.payment_receipt.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.payment_receipt.Setting/getSetting', data, errorback);
    },
}
export default Payment_receiptApi;



// WEBPACK FOOTER //
// ./src/api/payment_receipt.js